import React, {useState} from "react";
import "./navbar.scss";
import Logo from "../../Media/Logo_Greenbay (1).png";
import {HashLink} from "react-router-hash-link";
import {FaBars} from "react-icons/fa";
import {RiCloseLine} from "react-icons/ri";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div id="navbar" className="navbar">
      <div className="container-navbar">
        <div className="logo">
          <img src={Logo} alt="logo" />
        </div>
        <div className={isOpen ? "menus active" : "menus"}>
          <ul>
            <li>
              <HashLink className="link" smooth to="#about">
                About
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#produk">
                Products
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#fasilitas">
                Facillities
              </HashLink>
            </li>

            <li>
              <HashLink className="link" smooth to="#lokasi">
                Location
              </HashLink>
            </li>
          </ul>
        </div>

        <div className="icons" onClick={toggleMenu}>
          <FaBars className={isOpen ? "bars active" : "bars"} />
          <RiCloseLine className={isOpen ? "close active" : "close"} />
        </div>
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
